import {
  Flex,
  Text,
  Icon,
  Menu,
  MenuButton,
  Box,
  Center,
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { SET_SEARCH_TEXT } from "../../store/casestudy/casestudyActionTypes";

interface aa {
  logo: any;
  title: any;
  logoalt: any;
  hoveredlogo: any;
  path?: string;
  hoverStyles?: object;
}

const NavItem: React.FC<aa> = ({
  logo,
  title,
  logoalt,
  hoveredlogo,
  path,
  hoverStyles = {},
}: any) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    const checkActive = () => {
      const currentPath = window.location.pathname;
      setIsActive(path ? currentPath === path : false);
      // dispatch(setSearchText(""));
      dispatch({
        type: SET_SEARCH_TEXT,
        payload: "",
      });
    };

    checkActive();

    window.addEventListener("popstate", checkActive);
    return () => window.removeEventListener("popstate", checkActive);
  }, [path]);

  return (
    <>
      <Flex mt={1} flexDir="column" w="100%" alignItems="flex-start">
        <Menu placement="right">
          <Box
            p="12px 16px"
            borderRadius={132}
            _hover={{
              color: "#212121",
              bgGradient:
                "linear(90deg, rgba(54, 54, 54, 0.1) 0.07%, rgba(226, 68, 65, 0.00) 99.94%)",
              ...hoverStyles,
            }}
            bgGradient={
              isActive
                ? "linear(90deg, rgba(54, 54, 54, 0.1) 0.07%, rgba(226, 68, 65, 0.00) 99.94%)"
                : "none"
            }
            w="100%"
            color={isActive ? "#212121" : "#000"}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <MenuButton>
              <Flex>
                <img
                  src={isActive || isHovered ? hoveredlogo : logo}
                  alt={logoalt}
                  style={{ width: "24px", height: "24px" }}
                />
                <Text ml={5} display="flex">
                  {title}
                </Text>
              </Flex>
            </MenuButton>
          </Box>
        </Menu>
      </Flex>
    </>
  );
};
export default NavItem;
